import { render } from "./CreatePackage.vue?vue&type=template&id=86610a62"
import script from "./CreatePackage.vue?vue&type=script&lang=js"
export * from "./CreatePackage.vue?vue&type=script&lang=js"

import "./CreatePackage.vue?vue&type=style&index=0&id=86610a62&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__